import React, { useState, useEffect, useRef } from "react";
import Layout from "../../../Components/Layout/layout";
import dashboardclasses from "../../dashboard.module.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import ReactPaginate from "react-paginate";
import "../../../App.css";
import { css } from "@emotion/react";
import ScaleLoader from "react-spinners/ScaleLoader";
import { Services } from "../../../Services";
import { toast } from "react-toastify";
import Moment from "react-moment";
import { useNavigate, useSearchParams } from "react-router-dom";
import swal from "sweetalert";
import NotifyModal from "../notifications/modal";
function Products() {
    const Navigate = useNavigate();
    const [tableLoad, setTableLoad] = useState(true);
    const [params, setparams] = useSearchParams();
    const [sortBy, setSortBy] = useState(params.get("filter") || "");
    const [orderBy, setOrderBy] = useState(params.get("orderBy") || "");
    let [loading, setLoading] = useState(true);
    const [Navactive, setNavactive] = useState("1");
    const [showNotificationModal, setShowModal] = useState(false);
    const [NotificationID, setNotificationId] = useState("");
    const [mobile, setMobile] = useState(null);
    const [pageCount, setpageCount] = useState(1);
    const [orders, setOrders] = useState([]);
    const [showPaginate, setShowPagiate] = useState(true);
    const [forcePage, setForcePage] = useState(1);

    const token = { Authorization: `token ${sessionStorage.getItem("token")}` };
    const headerstyles = {
        color: "#707275",
        fontWeight: 700,
        fontSize: "0.8rem",
    };
    const override = css`
        display: block;
        margin: 0 auto;
        border-color: red;
    `;
    const clcikHanlder = (row, type) => {
        swal(
            `Are You sure you want to ${type == 0 ? "unblock" : "block"} user?`,
            {
                icon: "warning",
                className: dashboardclasses["logout-popup"],
                dangerMode: true,
                buttons: {
                    cancel: "Cancel",
                    catch: {
                        text: type == 0 ? "unblock" : "block",
                        value: "Delete",
                        className: dashboardclasses[".cancel-delete"],
                    },
                    defeat: false,
                },
            }
        ).then((value) => {
            switch (value) {
                case "Delete":
                    setLoading(true);
                    Services.MobilityDriverUserUpdate(
                        "PATCH",
                        JSON.stringify({ blocked: type }),
                        token,
                        row.id
                    )
                        .then((res) => {
                            if (res.Status === 1) {
                                getorders(
                                    params.get("page"),
                                    params.get("tab")
                                );
                                toast.success(`${res.Message}`, {
                                    position: "top-center",
                                    autoClose: 1000,
                                    hideProgressBar: true,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                });
                            } else if (res.Status === 0) {
                                setLoading(false);
                                toast.error(`${res.Message}`, {
                                    position: "top-center",
                                    autoClose: 1000,
                                    hideProgressBar: true,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                });
                                if (res.Message === "Token expired") {
                                    Navigate("/");
                                }
                            }
                        })
                        .catch((err) => {
                            // alert(err);
                            setLoading(false);
                            alert("something went wrong please try again");
                            console.log(err);
                        });
                    break;

                // default:
                //     swal("Got away safely!");
            }
        });
    };
    const ActionFormatter = (cell, row) => {
        return (
            <div className={dashboardclasses["Action_handler"]}>
                <button
                    onClick={(e) => {
                        e.stopPropagation();
                        clcikHanlder(row, row.blocked == 0 ? 1 : 0);
                    }}
                    className={
                        row.blocked == 0
                            ? dashboardclasses["red"]
                            : dashboardclasses["green"]
                    }>
                    {row.blocked == 0 ? "Block" : "Unblock"}{" "}
                </button>
                <button
                    style={{ border: "none", backgroundColor: "inherit" }}
                    onClick={(e) => {
                        {
                            e.preventDefault();
                            e.stopPropagation();
                            setShowModal(true);
                            setNotificationId(row.id);
                        }
                    }}>
                    Notify
                </button>
            </div>
        );
    };
    const getorders = (page, active) => {
        setTableLoad(true);
        Services.Mobility_Drivers(
            "GET",
            null,
            token,
            active,
            page,
            mobile,
            orderBy ? orderBy : null,
            sortBy ? sortBy : null
        )
            .then((res) => {
                console.log(res);
                setLoading(false);
                // setTabloader(false);
                setTableLoad(false);

                if (res.Status === 1) {
                    console.log(res);
                    setOrders(res.Drivers);
                    setpageCount(res?.Pagination?.totalPages);
                    if (res?.Pagination?.totalPages == 0) {
                        setShowPagiate(false);
                    }
                } else if (res.Status === 0) {
                    toast.error(`${res.Message}`, {
                        position: "top-center",
                        autoClose: 1000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    if (res.Message === "Token expired") {
                        Navigate("/");
                    }
                }
            })
            .catch((err) => {
                // alert(err);

                alert("something went wrong please try again");
                console.log(err);
            });
    };

    useEffect(() => {
        const handler = setTimeout(() => {
            setNavactive(params.get("tab"));
            getorders(params.get("page"), params.get("tab"));
            if (params.get("page")) {
                setpageCount(Number(params.get("page")));
                setForcePage(Number(params.get("page") - 1));

                // console.log(typeof params.get("page"));
            }
        }, 1000);
    }, [mobile, sortBy, orderBy]);
    const Idformatter = (cell, cellcontent, index, formatExtraData) => {
        return (
            <div>
                <p className={dashboardclasses["idformatter"]}>{cell}</p>
            </div>
        );
    };

    const priceFormatter = (cell) => {
        //className={dashboardclasses["priceformatter"]}
        return (
            <div className={dashboardclasses["price-wrapper"]}>
                <p>₹ {cell}</p>
            </div>
        );
    };
    const statusFormatter = (cell) => {
        //className={dashboardclasses["priceformatter"]}
        return (
            <div
                className={
                    cell == 0
                        ? dashboardclasses["status_inactive"]
                        : dashboardclasses["status_active"]
                }>
                {cell == 0 ? "inactive" : "Active"}
            </div>
        );
    };

    let columns = [
        {
            dataField: "name",
            text: "NAME",
            sort: false,

            headerStyle: (colum, colIndex) => {
                return {
                    ...headerstyles,
                };
            },
        },
        {
            dataField: "mobile",
            text: "CONTACT",
            sort: false,
            formatter: (cell, CellContent) => {
                return (
                    <p>
                        {cell},<br />
                        {CellContent?.emailid}
                    </p>
                );
            },
            // cell: (row, index) => index + 1,
            headerStyle: (colum, colIndex) => {
                return {
                    ...headerstyles,
                };
            },
        },

        /*  {
            dataField: "emailid",
            text: "EMAIL",
            sort: false,

            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        }, */
        {
            dataField: "dob",
            text: "DOB",
            sort: false,
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },
        {
            dataField: "createdAtFormatted",
            text: "REGISTERED",
            sort: false,
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },
        {
            dataField: "address",
            text: "ADDRESS",
            sort: false,
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },
        {
            dataField: "city",
            text: "CITY",
            sort: false,
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },

        {
            dataField: "serviceTypeName",
            text: "SERVICE",
            sort: false,

            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },
        {
            dataField: "rideWalletBalance",
            text: "WALLET AMOUNT",
            sort: false,
            formatter: priceFormatter,
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },
        {
            dataField: "isactive",
            text: "STATUS",
            sort: false,
            formatter: statusFormatter,
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },
        {
            dataField: "Actions",
            text: "Actions",
            sort: false,
            formatter: ActionFormatter,
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles, width: "100px" };
            },
        },
    ];
    const defaultSorted = [
        {
            dataField: "name",
            order: "desc",
        },
    ];
    const handlePageChange = (selectedObject) => {
        console.log(selectedObject);
        setForcePage(selectedObject.selected);
        window.scrollTo({ top: 10, behavior: "instant" });
        // Navigate(`/purchaseorder?page=${selectedObject.selected + 1}`);
        setparams({ page: selectedObject.selected + 1, tab: Navactive });
        getorders(selectedObject.selected + 1, Navactive);
        setTableLoad(true);
    };
    const searchHandler = (e) => {
        setTableLoad(true);
        setparams({ page: 1, tab: Navactive });
        setForcePage(1);
        setMobile(e.target.value);
        // setOrdersSearch(search);
    };

    const navactivehandler = (e) => {
        let status = e.currentTarget.getAttribute("id");
        setNavactive(status);

        setparams({ page: 1, tab: status });
        getorders(1, status);
    };

    const emptyDataMessage = () => {
        return "No Data to Display";
    };
    const tableRowEvents = {
        onClick: (e, row, rowIndex) => {
            e.preventDefault();
            Navigate(`/mobility-services/driver-details/${row.id}`);
        },
    };
    const onClose = () => {
        setShowModal("");
        setNotificationId("");
    };
    return (
        <>
            <Layout Active={"mobility_drivers"}>
                {showNotificationModal && (
                    <NotifyModal
                        onClose={onClose}
                        open={showNotificationModal}
                        userId={NotificationID}
                    />
                )}
                <div className={dashboardclasses["dashboard-rightside"]}>
                    <div className={dashboardclasses.CategoryWrapper}>
                        <h3>Drivers</h3>
                        {loading ? (
                            <div className={dashboardclasses["loader"]}>
                                <ScaleLoader
                                    color={"black"}
                                    loading={true}
                                    css={override}
                                    size={150}
                                />
                            </div>
                        ) : (
                            <>
                                <div
                                    className={
                                        dashboardclasses["category-form"]
                                    }>
                                    <input
                                        type={"text"}
                                        placeholder="search by Mobile number"
                                        onChange={searchHandler}
                                    />
                                    <select
                                        defaultValue={""}
                                        value={sortBy}
                                        onChange={(e) => {
                                            setSortBy(e.target.value);
                                            setparams({
                                                ...Object.fromEntries(
                                                    params.entries()
                                                ),
                                                filter: e.target.value,
                                            });
                                        }}>
                                        <option value="" disabled>
                                            filter By
                                        </option>
                                        <option value="0">Inactive</option>
                                        <option value="1">Active</option>
                                    </select>
                                    <select
                                        value={orderBy}
                                        defaultValue={""}
                                        onChange={(e) => {
                                            setOrderBy(e.target.value);
                                            setparams({
                                                ...Object.fromEntries(
                                                    params.entries()
                                                ),
                                                orderBy: e.target.value,
                                            });
                                        }}>
                                        <option value="" disabled>
                                            Order by
                                        </option>
                                        <option value="asc">Ascending</option>
                                        <option value="desc">descending</option>
                                    </select>
                                </div>
                                <div
                                    className={
                                        dashboardclasses["orders-navbar"]
                                    }>
                                    <button
                                        id="1"
                                        className={
                                            Navactive == "1" &&
                                            dashboardclasses["order-active"]
                                        }
                                        onClick={navactivehandler}>
                                        Approved
                                    </button>
                                    <button
                                        id="2"
                                        className={
                                            Navactive == "2" &&
                                            dashboardclasses["order-active"]
                                        }
                                        onClick={navactivehandler}>
                                        Pending Verification
                                    </button>
                                    <button
                                        id="3"
                                        className={
                                            Navactive == "3" &&
                                            dashboardclasses["order-active"]
                                        }
                                        onClick={navactivehandler}>
                                        Rejected
                                    </button>
                                    <button
                                        id="4"
                                        className={
                                            Navactive == "4" &&
                                            dashboardclasses["order-active"]
                                        }
                                        onClick={navactivehandler}>
                                        Document upload pending
                                    </button>
                                </div>

                                {tableLoad ? (
                                    <div className={dashboardclasses["loader"]}>
                                        <ScaleLoader
                                            color={"black"}
                                            loading={true}
                                            css={override}
                                            size={150}
                                        />
                                    </div>
                                ) : (
                                    <div className="category-table">
                                        <BootstrapTable
                                            bootstrap4
                                            keyField="id"
                                            data={orders}
                                            columns={columns}
                                            defaultSorted={defaultSorted}
                                            // pagination={pagination}
                                            wrapperClasses="table-responsive"
                                            noDataIndication={emptyDataMessage}
                                            rowEvents={tableRowEvents}
                                        />
                                        {showPaginate && (
                                            <div
                                                style={{
                                                    justifySelf: "right",
                                                }}>
                                                <ReactPaginate
                                                    pageCount={pageCount}
                                                    marginPagesDisplayed={2}
                                                    onPageChange={
                                                        handlePageChange
                                                    }
                                                    forcePage={forcePage}
                                                    breakClassName={"page-item"}
                                                    breakLinkClassName={
                                                        "page-link"
                                                    }
                                                    containerClassName={
                                                        "pagination"
                                                    }
                                                    pageClassName={"page-item"}
                                                    pageLinkClassName={
                                                        "page-link"
                                                    }
                                                    previousClassName={
                                                        "page-item"
                                                    }
                                                    previousLinkClassName={
                                                        "page-link"
                                                    }
                                                    nextClassName={"page-item"}
                                                    nextLinkClassName={
                                                        "page-link"
                                                    }
                                                    activeClassName={"active"}
                                                />
                                            </div>
                                        )}
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </Layout>
        </>
    );
}

export default Products;
